
<template>
  <div
    class="font-medium outer product-category"
  >
    <div
      class="d-flex pl-4 product-stripe"
      :class="{ isHover: isHover}"
    >
      <v-checkbox
        dense
        :input-value="selectedCategoriesMap[category.id]"
        @change="onChange($event)"
      >
        <template
          v-slot:label
        >
          <span class="text">{{ category.categoryName }} ({{ category.subCategories.length }})</span>
        </template>
      </v-checkbox>

      <button
        :id="'label-' + _uid"
        :disabled="category.subCategories.length === 0"
        style="flex: 1; text-align: end"
        :aria-expanded="isOpen"
        :aria-controls="'body-' + _uid"
        :aria-label="(isOpen ? 'Collapse ' : 'Expand ') + category.categoryName"
        class="mr-4"
        @click="isOpen = !isOpen"
        @mouseover="isHover = true"
        @mouseleave="isHover = false"
      >
        <v-icon
          class="prod-icon"
          :class="{ spun: isOpen}"
        >
          {{ category.subCategories.length === 0 ? '' : 'mdi-chevron-down' }}
        </v-icon>
      </button>
    </div>

    <div
      class="line"
    />

    <div
      :id="'body-' + _uid"
      role="region"
      :aria-labelledby="'label-' + _uid"
    >
      <transition name="slide">
        <div
          v-if="isOpen"
          style="margin-left: 24px"
        >
          <product-category
            v-for="cat in category.subCategories"
            :key="cat.id"
            :category="cat"
            :selected-categories-map="selectedCategoriesMap"
            @updated="onUpdatedChild($event)"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCategory',
  props: {
    category: {
      type: Object,
      required: true
    },
    selectedCategoriesMap: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isOpen: false,
    isHover: false
  }),
  methods: {
    onChange (e) {
      this.$emit('updated', {
        category: this.category,
        crumb: '',
        isSelected: e
      })
    },
    onUpdatedChild (val) {
      val.crumb = this.category.categoryName + ' / ' + val.crumb
      this.$emit('updated', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/styles/variables';
.prod-icon {
    transition: transform 0.3s;
}

.spun {
    transform: rotate(180deg);
}

.text {
    font-weight: normal !important;
}

.line {
    width: 100%;
    height: 1px;
    background-color: $light-grey;
}

button:disabled {
    cursor: default;
}

.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 500px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}

.isHover {
    background-color: $even-lighter-grey;
}
</style>

<style lang="scss">

.product-category {
.v-messages {
    height: 0px !important;
    min-height: 0px !important;
}
}

</style>
